var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.panel
    ? _c(
        "v-expansion-panel",
        { staticClass: "emc-selectable-list" },
        [
          _c(
            "v-expansion-panel-header",
            { staticClass: "px-3 py-0 emc-selectable-list__header" },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { gap: "8px" },
                },
                [
                  _vm.icon
                    ? _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(_vm._s(_vm.icon)),
                      ])
                    : _vm._e(),
                  _c(
                    "span",
                    { staticClass: "text-body-2 font-weight-medium" },
                    [_vm._v(_vm._s(_vm.label))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-chip",
                    {
                      staticClass: "flex-grow-0 mr-2",
                      attrs: {
                        "x-small": "",
                        label: "",
                        outlined: "",
                        color: "primary",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedCount) +
                          " / " +
                          _vm._s(_vm.items.length) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("v-expansion-panel-content", [
            _c(
              "div",
              { staticClass: "emc-selectable-list__body" },
              [
                (_vm.selectAll && !_vm.disabled) || _vm.searchable
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex align-center pt-2",
                        staticStyle: { gap: "8px" },
                      },
                      [
                        _vm.searchable
                          ? _c("v-text-field", {
                              attrs: {
                                dense: "",
                                outlined: "",
                                "hide-details": "",
                                clearable: "",
                                "prepend-inner-icon": "mdi-magnify",
                                label: _vm.searchLabel,
                                disabled: _vm.disabled,
                              },
                              model: {
                                value: _vm.search,
                                callback: function ($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search",
                              },
                            })
                          : _c("v-spacer"),
                        _vm.selectAll && !_vm.disabled
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "text-caption primary--text text-no-wrap",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.toggleAll.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.allSelected ? "Limpar" : "Todos"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._t("filter"),
                _vm.loading
                  ? _c("v-progress-linear", {
                      staticClass: "mt-1",
                      attrs: { indeterminate: "", color: "primary" },
                    })
                  : _vm._e(),
                _vm.hasError
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "text-center red--text text-caption mb-0 mt-1",
                      },
                      [_vm._v(_vm._s(_vm.errors[0]))]
                    )
                  : _vm._e(),
                _c(
                  "emc-util-scroll",
                  { attrs: { height: _vm.height } },
                  [
                    _c(
                      "v-list",
                      { staticClass: "py-0", attrs: { dense: "" } },
                      [
                        _vm.displayItems.length
                          ? _vm._l(_vm.displayItems, function (item) {
                              return _c(
                                "v-list-item",
                                {
                                  key: item[_vm.itemValue],
                                  attrs: {
                                    disabled: _vm.disabled,
                                    "input-value": _vm.isSelected(item),
                                    "active-class": "primary--text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggle(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-action",
                                    { staticClass: "mr-3 my-0" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: _vm.isSelected(item)
                                              ? "primary"
                                              : "grey lighten-1",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.isSelected(item)
                                                  ? "mdi-checkbox-marked"
                                                  : "mdi-checkbox-blank-outline"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(item[_vm.itemText])),
                                      ]),
                                      !!_vm.$scopedSlots.subtitle
                                        ? _c(
                                            "v-list-item-subtitle",
                                            [
                                              _vm._t("subtitle", null, {
                                                item: item,
                                              }),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  !!_vm.$scopedSlots.meta
                                    ? _c(
                                        "v-list-item-action",
                                        { staticClass: "my-0" },
                                        [
                                          _c(
                                            "v-list-item-action-text",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._t("meta", null, {
                                                item: item,
                                              }),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            })
                          : !_vm.loading
                          ? _c(
                              "v-list-item",
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass:
                                          "text-caption grey--text text-center",
                                      },
                                      [_vm._v(" Nenhum item encontrado ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]),
        ],
        1
      )
    : _c(
        "v-sheet",
        {
          staticClass: "emc-selectable-list",
          attrs: { outlined: "", rounded: "" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-center px-3 py-1 emc-selectable-list__header",
            },
            [
              _vm.icon
                ? _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { "x-small": "" } },
                    [_vm._v(_vm._s(_vm.icon))]
                  )
                : _vm._e(),
              _c("span", { staticClass: "text-caption font-weight-medium" }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
              _c("v-spacer"),
              _vm.selectAll && !_vm.disabled
                ? _c(
                    "a",
                    {
                      staticClass: "text-caption mr-3 primary--text",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleAll.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.allSelected ? "Limpar" : "Todos") + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "v-chip",
                {
                  attrs: {
                    "x-small": "",
                    label: "",
                    outlined: "",
                    color: "primary",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.selectedCount) + " / " + _vm._s(_vm.items.length)
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.searchable
            ? _c(
                "div",
                { staticClass: "px-3 pt-2" },
                [
                  _c("v-text-field", {
                    attrs: {
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      clearable: "",
                      "prepend-inner-icon": "mdi-magnify",
                      label: _vm.searchLabel,
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._t("filter"),
          _vm.loading
            ? _c("v-progress-linear", {
                staticClass: "mt-1",
                attrs: { indeterminate: "", color: "primary" },
              })
            : _vm._e(),
          _vm.hasError
            ? _c(
                "p",
                { staticClass: "text-center red--text text-caption mb-0 mt-1" },
                [_vm._v(_vm._s(_vm.errors[0]))]
              )
            : _vm._e(),
          _c(
            "emc-util-scroll",
            { attrs: { height: _vm.height } },
            [
              _c(
                "v-list",
                { staticClass: "py-0", attrs: { dense: "" } },
                [
                  _vm.displayItems.length
                    ? _vm._l(_vm.displayItems, function (item) {
                        return _c(
                          "v-list-item",
                          {
                            key: item[_vm.itemValue],
                            attrs: {
                              disabled: _vm.disabled,
                              "input-value": _vm.isSelected(item),
                              "active-class": "primary--text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggle(item)
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-action",
                              { staticClass: "mr-3 my-0" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: _vm.isSelected(item)
                                        ? "primary"
                                        : "grey lighten-1",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.isSelected(item)
                                            ? "mdi-checkbox-marked"
                                            : "mdi-checkbox-blank-outline"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item[_vm.itemText])),
                                ]),
                                !!_vm.$scopedSlots.subtitle
                                  ? _c(
                                      "v-list-item-subtitle",
                                      [
                                        _vm._t("subtitle", null, {
                                          item: item,
                                        }),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            !!_vm.$scopedSlots.meta
                              ? _c(
                                  "v-list-item-action",
                                  { staticClass: "my-0" },
                                  [
                                    _c(
                                      "v-list-item-action-text",
                                      { staticClass: "text-right" },
                                      [_vm._t("meta", null, { item: item })],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      })
                    : !_vm.loading
                    ? _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "text-caption grey--text text-center",
                                },
                                [_vm._v(" Nenhum item encontrado ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }